import { GeneralAARUISingleEntryConfig } from "../Components/ui/react/core-general-aar-ui";
import { PageType } from "../../misc/tools";

export class GameDataManager<ConfigType extends GameDataConfig<SingleScenarioConfig>> {
    constructor(public data: ConfigType) {}
}

export interface GameDataConfig<ScenarioType extends SingleScenarioConfig> {
    isVisibleFocusEnabled: boolean;
    isAudioEnabled: boolean;
    fontSizeMultiplier: FontSizeMultiplier;
    isClosedCaptionEnabled: boolean;
    isMotionEnabled: boolean;
    isAnimationsEnabled: boolean;
    lastVisitedScenarioIndx: number;
    scenarios: ScenarioType[];
}

export interface SingleScenarioConfig {
    scenarioWindow: PageType;
    isLocked: boolean;
    isCompleted: boolean;
    score: number;
    maxScore: number;
    area: number;
    CurrentQuestion: number;
    MaxQuestions: number;
    aarEntries: GeneralAARUISingleEntryConfig[];
    isComingSoon?: boolean;
}

export enum FontSizeMultiplier {
    small = 0.5,
    med = 1,
    big = 1.5
}